var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "All Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_back_ios_new",
    d: "M17.5222 9.05152C17.7861 9.31539 17.7861 9.74321 17.5222 10.0071L11.5 16.0293L5.47778 10.0071C5.21391 9.74321 5.21391 9.31539 5.47778 9.05152C5.74165 8.78765 6.16947 8.78765 6.43334 9.05152L11.5 14.1182L16.5667 9.05152C16.8305 8.78765 17.2583 8.78765 17.5222 9.05152Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.277907dac3584c2dfb6336ccf8c95da1.svg";
export { ForwardRef as ReactComponent };